import { ArticleType } from "../enums/articleTypeEnum";
import { Supplier } from "./supplier";

export interface Article {
  id: string | null;
  verified: boolean;
  reviewedQuote: boolean;
  isSyncedWithAX: boolean;
  externalId: string;
  articleNumber: string;
  adId: string;
  description: string;
  salesOrderNumber: string;
  purchaseOrderNumber: string;
  internalComment: string;
  comment: string;
  externalArticleCode: string;
  quantity: number;
  rowNumber: number;
  purchasePrice: string;
  salesPrice: string;
  workshopSalesPrice: string;
  storeSalesPrice: string;
  vat: number;
  deliveredQuantity: number;
  supplierId: string | null;
  supplier: Supplier | null;
  articleTemplateId?: string | null;
  totalExVat: number;
  totalIncVat: number;
  discount: number | null;
  partUrl: string | null;
  excludeFromWarehousePicking: boolean;
  time: number;
  articleType?: ArticleType;
  externalDescription?: string;
  stock?: number | null;
}

export const defaultArticle: Article =
{
  id: null,
  verified: false,
  reviewedQuote: false,
  isSyncedWithAX: false,
  externalId: "",
  articleNumber: "",
  adId: "",
  description: "",
  salesOrderNumber: "",
  purchaseOrderNumber: "",
  internalComment: "",
  comment: "",
  externalArticleCode: "",
  quantity: 0,
  rowNumber: 0,
  purchasePrice: "0",
  salesPrice: "0",
  workshopSalesPrice: "0",
  storeSalesPrice: "0",
  vat: 0,
  deliveredQuantity: 0,
  supplierId: null,
  supplier: null,
  articleTemplateId: null,
  totalExVat: 0,
  totalIncVat: 0,
  discount: null,
  partUrl: null,
  excludeFromWarehousePicking: false,
  time: 0,
  articleType: ArticleType.Product,
  externalDescription: "",
  stock: null
};
